import React from 'react';
import { Field } from 'redux-form';
import { Checkbox, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';

import { Filters } from '../../components/shared';

export default ({ handleFilter, handleResetFilter, filterValues }) => {
  const fieldMap = {
    isRecurring: 'Recurring?',
    status: 'Status',
    hasStudentRating: 'Has Student Rating',
    hasTutorRating: 'Has Tutor Rating',
    sessionStatus: 'Session Status',
    requestType: 'Request Type',
  };

  return (
    <Filters
      handleFilter={handleFilter}
      handleResetFilter={handleResetFilter}
      fieldMap={fieldMap}
      values={filterValues}
    >
      <Field name="status" floatingLabelText="Status" component={SelectField}>
        <MenuItem value="" primaryText="" />
        <MenuItem value="Started" primaryText="Started" />
        <MenuItem value="Completed" primaryText="Completed" />
      </Field>
      <br />
      <Field
        name="sessionStatus"
        floatingLabelText="Session Status"
        component={SelectField}
      >
        <MenuItem value="" primaryText="" />
        <MenuItem value="Started" primaryText="Started" />
        <MenuItem value="Completed" primaryText="Completed" />
      </Field>
      <br />
      <Field
        name="requestType"
        floatingLabelText="Request Type"
        component={SelectField}
      >
        <MenuItem value="" primaryText="" />
        <MenuItem value="Direct" primaryText="Direct" />
        <MenuItem value="Common" primaryText="Common" />
      </Field>
      <br />
      <Field name="isRecurring" label="Is Recurring" component={Checkbox} />
      <br />
      <Field
        name="hasStudentRating"
        label="Has Student Rating"
        component={Checkbox}
      />
      <Field
        name="hasTutorRating"
        label="Has Tutor Rating"
        component={Checkbox}
      />
    </Filters>
  );
};



// WEBPACK FOOTER //
// ./src/modules/job/JobsFilter.js